import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty } from 'lodash';
import { Message } from 'semantic-ui-react';
import { allowAccess } from '../utilities/user';
import requireAuth from './RequireAuth';
import StoreInsertion from './StoreInsertion';
import NotFound from '../views/NotFound';
import ACCESS from '../constants/access';
import APP_PATH from '../constants/paths';

// Helper function for auction location logic
// now if we disable the flag for Auction locations toggle this page will be considered as not found,
// Currently, this role will for all user,
// if we need this page for specific user we can disable it and show the alert in the Message
const isAuctionLocationAccessible = (user, pathname) => (
  user
    && user.roles
    && pathname
    && pathname.includes(APP_PATH.AUCTION_LOCATION)
    && !ACCESS.FLAG_AUCTION_LOCATIONS.matchAll.some(role => user.roles.includes(role))
);

const authorize = (allowedRoles, extraProps) => WrappedComponent => {
  const WithAuthorization = props => {
    const {
      user,
      location: { pathname },
    } = props;

    useEffect(() => {
      StoreInsertion(props, extraProps);
    }, [props]);

    if (allowAccess(user, allowedRoles)) {
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      return <WrappedComponent {...props} />;
    }
    if (isAuctionLocationAccessible(user, pathname)) {
      return <NotFound />;
    }
    if (!isEmpty(user)) {
      return (
        <Message
          error
          header='You do not have permissions to view this page.'
          list={[
            'Please contact Dealshield support, to enable the right permissions, in case you need to view this page.',
          ]}
        />
      );
    }
    return <p />;
  };

  WithAuthorization.propTypes = {
    user: PropTypes.shape({
      roles: PropTypes.arrayOf(PropTypes.string),
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  };

  WithAuthorization.defaultProps = {
    user: null,
  };

  const mapStateToProps = state => ({ user: state.data.user });

  return compose(requireAuth, connect(mapStateToProps, null))(
    WithAuthorization
  );
};

export default authorize;
